var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3705_21441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.484 0H4.51602C2.02189 0 0 2.04066 0 4.55794V15.5347C0 18.052 2.02189 20.0926 4.51602 20.0926H15.484C17.9781 20.0926 20 18.052 20 15.5347V4.55794C20 2.04066 17.9781 0 15.484 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6456 5.82178H14.0566L10.9742 9.36153L14.6003 14.1779H11.7609L9.53705 11.257L6.99213 14.1779H5.58041L8.87729 10.3921L5.39877 5.82178H8.3101L10.3203 8.4919L12.6456 5.82178ZM12.1503 13.3294H12.9324L7.88549 6.62587H7.04643L12.1503 13.3294Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3705_21441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.fa7d3066ccd305306186b736a9a3d637.svg";
export { ForwardRef as ReactComponent };